<template>
    <svg class="icon-cross fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.04 24.04"><polygon points="24.04 22.63 13.44 12.02 24.04 1.41 22.63 0 12.02 10.61 1.42 0 0 1.41 10.61 12.02 0 22.63 1.41 24.04 12.02 13.43 22.63 24.04 24.04 22.63"/></svg>
</template>
